(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/module/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/core/module/assets/javascripts/prescript.js');
"use strict";


svs.core = svs.core || {};
svs.core.module = {};
svs.core.module.helpers = {};

 })(window);